module.exports = "<div class=\"cont_loading\">\n  <div class=\"circle_loader_ciber\"></div>\n  <div class=\"circle_loader_ciber\"></div>\n</div>\n"